<template>
  <div
    id="modal-main"
    class="modal-main"
  >
    <a-modal
      v-model:visible="openLoginModal"
      :footer="null"
      :closable="false"
      width="500px"
      :body-style="{
        padding: 0,
      }"
      class="custom-modal"
    >
      <div class="modal-counter">
        <img
          class="close-icon"
          src="../assets/img/close-icon.png"
          alt=""
          @click="handleCloseModal"
        >
        <div class="top-bg">
          <!-- 登录 -->
          <div class="login-type-counter">
            <div
              class="login-type"
              :class="{ actived: activeKey == 1 }"
              @click="handleChangeLoginType(1)"
            >
              账号登录
            </div>
            <div
              class="login-type"
              :class="{ actived: activeKey == 2 }"
              @click="handleChangeLoginType(2)"
            >
              手机号登录
            </div>
          </div>
        </div>
        <div class="form-main">
          <!-- <a-tabs
            v-model:activeKey="activeKey"
            :tab-bar-gutter="20"
          >
            <a-tab-pane
              key="1"
              tab="账号登录"
            />
            <a-tab-pane
              key="2"
              tab="手机注册"
            />
          </a-tabs> -->
          <!-- <a-form
            :model="loginForm"
            name="basic"
            autocomplete="off"
          >
            <div v-if="activeKey == 1">
              <a-form-item>
                <a-input
                  v-model:value="loginForm.username"
                  placeholder="请输入手机号"
                />
              </a-form-item>
              <a-form-item>
                <a-input-password
                  v-model:value="loginForm.password"
                  placeholder="请输入密码"
                />
              </a-form-item>
            </div>
            <div v-else>
              <a-form-item>
                <a-input
                  v-model:value="loginForm.phone"
                  placeholder="请输入手机号"
                />
              </a-form-item>
              <a-form-item>
                <div class="code-input-main">
                  <a-input
                    v-model:value="loginForm.code"
                    placeholder="请输入验证码"
                    style="width: 80%"
                  />
                  <span
                    v-if="!countFlag"
                    @click="handleStartCountdown"
                  >获取验证码</span>
                  <span
                    v-else
                    class="count-down"
                  >{{ countDown }}</span>
                </div>
              </a-form-item>
            </div>
            <a-button
              type="primary"
              style="margin-top: 72px"
              block
              @click="handleLogin"
            >
              登录
            </a-button>
          </a-form> -->

          <div
            class="input-counter"
          >
            <mobile-outlined
              :style="{
                fontSize: '22px',
                color: '#E9E9E9',
              }"
            />
            <label
              class="input-label"
              :class="{
                active: focusFlag == 1,
              }"
            >
              {{ activeKey == 2 ? '请输入手机号' : '请输入账号' }}
            </label>
            <input
              type="tel"
              class="input-filed"
              :value="loginForm.phone"
              :placeholder="activeKey == 2 ? '请输入手机号' : '请输入账号'"
              @focus="handleFocus(1)"
              @blur="handleBlur"
              @input="handleChangePhone"
            >
          </div>
          <div
            v-if="activeKey == 1"
            class="input-counter"
            style="margin-top: 40px"
          >
            <mobile-outlined
              :style="{
                fontSize: '22px',
                color: '#E9E9E9',
              }"
            />
            <label
              class="input-label"
              :class="{
                active: focusFlag == 3,
              }"
            >
              请输入密码
            </label>
            <input
              :type="checkPasswordFlag ? 'text' : 'password'"
              class="input-filed"
              :value="loginForm.password"
              placeholder="请输入密码"
              @focus="handleFocus(3)"
              @blur="handleBlur"
              @input="handleChangePassword"
            >
            <eye-outlined
              v-if="checkPasswordFlag"
              :style="{
                color: '#8c8c8c',
                fontSize: '18px',
                cursor: 'pointer',
              }"
              @click="handleOpenPassword(false)"
            />
            <eye-invisible-outlined
              v-else
              :style="{
                color: '#8c8c8c',
                fontSize: '18px',
                cursor: 'pointer',
              }"
              @click="handleOpenPassword(true)"
            />
          </div>
          <div
            v-if="activeKey == 2"
            class="input-counter verification-main"
            style="margin-top: 40px"
          >
            <safety-certificate-outlined
              :style="{
                fontSize: '22px',
                color: '#E9E9E9',
              }"
            />
            <label
              class="input-label"
              :class="{
                active: focusFlag == 2,
              }"
            >
              请输入验证码
            </label>
            <div class="right-input-code">
              <input
                type="tel"
                class="input-filed"
                placeholder="验证码"
                :value="loginForm.code"
                @focus="handleFocus(2)"
                @blur="handleBlur"
                @input="handleChangeCode"
              >
              <div
                class="acquire-code"
                @click="handleStartCountdown"
              >
                {{ !countFlag ? "获取验证码" : countDown + "S" }}
              </div>
            </div>
          </div>
          <div
            class="login-btn"
            @click="handleLogin"
          >
            登录
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script setup>
import { message } from 'ant-design-vue';
import { computed, ref } from 'vue';
import { useModal } from '../store/index';
import {
  getPublicSms,
  getMemberToken,
  getPhonePasswordLogin,
} from '@/api/auth/login';
import { getUserInfo } from '@/api/control/info';
import router from '@/router';
import {
  MobileOutlined,
  SafetyCertificateOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
} from '@ant-design/icons-vue';

const useModalStore = useModal();
const openLoginModal = computed(() => {
  return useModalStore.modalVal;
});

const activeKey = ref('1');
const loginForm = ref({});
const countDown = ref(59);
const countFlag = ref(false);
const timer = ref(null);
const focusFlag = ref(0);
const checkPasswordFlag = ref(false);

const handleCloseModal = () => {
  useModalStore.changeModal(false);
  clearInterval(timer.value);
  countFlag.value = false;
  loginForm.value = {};
};

const handleChangeLoginType = (type) => {
  loginForm.value = {};
  activeKey.value = type;
};

const handleStartCountdown = async () => {
  try {
    if (!loginForm.value.phone) {
      return message.warning('请您先填写手机号');
    }
    if (!/^1\d{10}$/.test(loginForm.value.phone)) {
      return message.warning('请输入正确的手机号码');
    }
    if (countFlag.value) return;
    countFlag.value = true;
    timer.value = setInterval(() => {
      countDown.value--;
      if (countDown.value == 0) {
        countFlag.value = false;
        countDown.value = 59;
        clearInterval(timer.value);
      }
    }, 1000);
    await getPublicSms(loginForm.value.phone);
    message.success('发送验证码成功');
  } catch (err) {
    console.log(err);
    countFlag.value = false;
    countDown.value = 59;
    clearInterval(timer.value);
  }
};

// 登录
const handleLogin = async () => {
  try {
    let resData = null;
    if (activeKey.value == 2) {
      if (!loginForm.value.phone || !loginForm.value.code) {
        return message.warning('请您先填写登录信息');
      }
      resData = await getMemberToken(
        loginForm.value.phone,
        loginForm.value.code
      );
    } else {
      if (!loginForm.value.phone || !loginForm.value.password) {
        return message.warning('请您先填写登录信息');
      }
      // const formData = new FormData();
      // formData.append('username', loginForm.value.phone);
      // formData.append('password', loginForm.value.password);
      resData = await getPhonePasswordLogin({
        username: loginForm.value.phone,
        password: loginForm.value.password,
        randomStr: 'noCodeType',
        grant_type: 'password',
      });
    }
    useModalStore.changeUserInfo(resData?.data || resData);
    const userInfo = await getUserInfo({
      userId: resData?.data?.user_id || resData?.user_id,
    });
    if (userInfo?.data?.status == 2) {
      // 此用户账号停用
      return message.error('账号已停用，请联系客服');
    }
    message.success('登录成功');
    await useModalStore.getUserInfo(resData?.data || resData);
    handleCloseModal();
    if (useModalStore.userJumpFlag == 2) {
      router.push('/control/index');
    } else if (useModalStore.userJumpFlag == 3) {
      router.push('/ability/index');
    }
  } catch (err) {
    console.log(err);
  }
};

const handleFocus = (type) => {
  focusFlag.value = type;
};
const handleBlur = () => {
  focusFlag.value = 0;
};

const handleChangePhone = (e) => {
  loginForm.value.phone = e.target.value;
};
const handleChangeCode = (e) => {
  loginForm.value.code = e.target.value;
};
const handleChangePassword = (e) => {
  loginForm.value.password = e.target.value;
};

// 是否查看密码
const handleOpenPassword = (flag) => {
  checkPasswordFlag.value = flag;
  focusFlag.value = 3;
};
</script>

<style>
.custom-modal .ant-modal-content {
  border-radius: 16px !important;
}

/* 确保 modal 始终在最上层，不被 mavon-editor 遮挡 */
.custom-modal.ant-modal {
  z-index: 9999 !important;
}

.modal-main {
  z-index: 9999 !important;
}
</style>
<style scoped>
/* :deep(.ant-modal-content) {
  border-radius: 16px !important;
} */
::v-deep .ant-tabs-tab-btn {
  /* 200 */
  width: 420px;
  text-align: center;
}
</style>
<style lang="scss" scoped>
@function toVw($px) {
  @return ($px / 1920) * 100vw;
}
@function toVh($px) {
  @return ($px / 1080) * 100vh;
}
.modal-counter {
  position: relative;
  .close-icon {
    width: 30px;
    height: 30px;
    position: absolute;
    top: 0;
    right: -50px;
    cursor: pointer;
  }
  .top-bg {
    height: 140px;
    background: url("../assets/img/login-bg.png") no-repeat;
    background-size: cover;
    padding: 50px 70px 40px 70px;
    border-radius: 16px;
    .login-type-counter {
      display: flex;
      align-items: center;
      justify-content: space-around;
      .login-type {
        cursor: pointer;
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        position: relative;
        &.actived {
          color: #13be88;
          font-weight: 500;
          &::after {
            content: "";
            width: 30px;
            height: 4px;
            background: #13be88;
            border-radius: 10px 10px 10px 10px;
            position: absolute;
            bottom: -6px;
            left: calc(50% - 15px);
          }
        }
      }
    }
  }
  .form-main {
    padding: 0 40px 80px 40px;
    // .code-input-main {
    // display: flex;
    // align-items: center;
    // span {
    //   font-weight: 400;
    //   font-size: 14px;
    //   color: #13be88;
    //   padding: 4px 6px;
    //   border: 1px solid #d9d9d9;
    //   border-left: none;
    //   cursor: pointer;
    // }
    // .count-down {
    //   width: 90px;
    //   text-align: center;
    // }
    // }

    .input-counter {
      width: 360px;
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 14px 12px;
      box-sizing: border-box;
      border-radius: 4px;
      border: 1px solid #e9e9e9;
      margin: auto;
      position: relative;
      .anticon {
        border: none;
      }
      .input-label {
        position: absolute;
        left: 40px;
        top: -6%;
        transform: translateY(-40%);
        background-color: white;
        padding: 0 5px;
        transition: 0.2s ease;
        font-weight: 400;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.45);
        &.active {
          // top: -2px;
          color: #38cf98;
        }
      }
      .input-filed {
        width: 100%;
        border: none;
        transition: border-color 0.2s;
        font-weight: 400;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.85);
        &:focus {
          outline: none;
          .input-counter {
            border-color: #13be88;
          }
        }
        &::placeholder {
          font-weight: 400;
          font-size: 16px;
          color: #d3d3d3;
        }
      }
    }
    .verification-main {
      .right-input-code {
        .input-filed {
          width: 64%;
        }
        width: 100%;
        display: flex;
        align-content: center;
        justify-content: space-between;
        .acquire-code {
          height: 100%;
          cursor: pointer;
          font-weight: 400;
          font-size: 15px;
          color: #38cf98;
          text-align: right;
        }
      }
    }
    .login-btn {
      margin: 52px auto 0 auto;
      width: 360px;
      background: #38cf98;
      border-radius: 4px 4px 4px 4px;
      padding: 6px 0;
      text-align: center;
      font-weight: 600;
      font-size: 24px;
      color: #ffffff;
      cursor: pointer;
    }
  }
}
</style>
